module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Night-fog-3d8393af6ef87af77de9465acd6c74f1.svg";